import React, { useEffect, useState } from "react";
import Card from "../../../common/Card/Card";
import Table from "../../../common/Table/Table";
import {
  getuserTransactionAction,
  getCoinListAction,
} from "../../../../features/user/userSlice";
import { useDispatch } from "react-redux";
import { formatPrice, formatCryptoPrice, toFix } from "../../../../utils/utils";
import Commonpagination from "../../../common/Pagination/Commonpagination";
import { useSelector } from "react-redux";
import format from "date-fns/format";
import { useLocation } from "react-router-dom";
import Select from "../../../common/Formik/Select/Select";
import stbltrackIcon from "../../../../assets/icons/stbltrackIcon.svg";
import style from "./ReportDetails.module.scss";

const UserReportDetailTransactions = () => {
  const location = useLocation();
  const { user } = location.state || {};
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [userBalanceData, setUserBalanceData] = useState([]);
  const [userDetail, setUserData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [coinList, setCoinList] = useState([]);
  const size = 10;
  const userData = useSelector((state) => state?.persist?.userInfo);
  const defaultCoin = user?.coin_name;
  const defaultCoinBlnc = user?.balance;
  const [coinBalance, setCoinBalance] = useState(defaultCoinBlnc);
  const [selectedCoin, setSelectedCoin] = useState(defaultCoin);

  const decimalLimit = useSelector((state) => state?.users?.coinDecimals);

  const tableHeaders = [
    { label: "S.No" },
    { label: "Country	" },
    { label: "Date & Time" },
    { label: "Txn Type" },
    { label: "Debit/Credit" },
    { label: "Platform Fees" },
    { label: "Gas Fees" },
    { label: "Balance" },
  ];

  const Options = [
    { value: "", label: "ALL" },
    { value: "BUY", label: "BUY" },
    { value: "SELL", label: "SELL" },
    // { value: "CONVERT", label: "CONVERT" },
    { value: "DEPOSIT", label: "DEPOSIT" },
    { value: "WITHDRAW", label: "WITHDRAW" },
  ];
  const [selectedTransactionType, setSelectedTransactionType] = useState("");
  const sellOptions = [
    { value: "", label: "ALL" },
    { value: "MARKETPLACE", label: "MARKETPLACE" },
    { value: "REDEMPTION", label: "REDEMPTION" },
    // { value: "P2P", label: "P2P" },
    // { value: "CONVERT", label: "CONVERT" },
    { value: "SELLTOUS", label: "SELL TO US" },
    { value: "PHYSICALREDEEM", label: "PHYSICAL REDEEM" },
  ];
  const [nestedOptions, setNestedOptions] = useState("");

  const fetchCoinList = async () => {
    try {
      const response = await dispatch(getCoinListAction());
      if (response?.status === 200) {
        const coins = response.data.data.data.map((coin) => ({
          value: coin.symbol,
          //label: coin.name,
          label:
            coin.name && coin.name === "USD STBL" ? coin.name : coin.symbol,
          balance: coin.balance,
        }));
        setCoinList(coins);
      }
    } catch (error) {
      console.error("Error fetching coin list:", error);
    }
  };

  const fetchFiatWithdrawHistory = async () => {
    setLoading(true);
    const dataObj = {
      size: size,
      page: page,
      coin: selectedCoin,
      user_id: user?.user_id,
      transactionType: selectedTransactionType,

      orderCreatedFrom: nestedOptions,
    };
    try {
      const response = await dispatch(getuserTransactionAction(dataObj));
      if (response?.data?.status === 200) {
        setUserData(response.data.data);
        setUserBalanceData(response.data.data.list);
        const rawBalance = response.data.data.user_balance;

        // extract numeric value even if symbol is attached
        const numericBalance = rawBalance
          ? parseFloat(rawBalance.toString())
          : 0;

        setCoinBalance(numericBalance);

        // setCoinBalance(response.data.data.user_balance);
      }
    } catch (error) {
      console.error("Error fetching withdraw list:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchFiatWithdrawHistory();
  }, [
    page,
    size,
    selectedCoin,
    selectedTransactionType,
    nestedOptions,
    user?.user_id,
  ]);
  const handleFilterChange = (key, value) => {
    setPage(1);

    if (key === "coin") {
      if (value === selectedCoin) {
        fetchFiatWithdrawHistory();
      } else {
        setSelectedCoin(value);
        setCoinBalance(0);
        setUserBalanceData([]);
      }
    } else if (key === "transactionType") {
      setSelectedTransactionType(value);
    } else if (key === "orderCreatedFrom") {
      setNestedOptions(value);
    }
  };

  useEffect(() => {
    fetchCoinList();
  }, []);

  return (
    <section className={style.reportDetail}>
      <div className={style.transactonField}>
        <h2>Transaction Track</h2>
      </div>
      <div className={style.reportdetailTopHead}>
        <ul>
          <li>
            <div className={style.icon_track}>
              <img src={stbltrackIcon} alt="icons" />
            </div>
            <div className={style.text_sec}>
              <h4 className="big">
                {/* {selectedCoin} Holding of {user?.username} */}
                {selectedCoin} Holding
              </h4>
              <label>
                {Number.isFinite(Number(coinBalance))
                  ? `${toFix(
                      coinBalance,
                      decimalLimit?.[selectedCoin] ?? 3,
                    )} ${selectedCoin}`
                  : `0 ${selectedCoin}`}
              </label>

              {/* <label>
                {selectedCoin === "BTC" || selectedCoin === "ETH"
                  ? formatCryptoPrice(coinBalance)
                  : toFix(coinBalance, 3)}{" "}
                {selectedCoin !== "BTC" && selectedCoin !== "ETH"
                  ? selectedCoin
                  : ""}
              </label> */}
            </div>
          </li>
        </ul>
        <div className={style.transactonSelect}>
          <Select
            className={style.select_time}
            options={coinList}
            formatOptionLabel={(option) => <h5>{option.label}</h5>}
            placeholder={
              <h5>
                {coinList?.find(
                  (coin) =>
                    coin.value === selectedCoin || coin.label === selectedCoin,
                )?.label || "Select Coin"}
              </h5>
            }
            isSearchable={false}
            defaultValue={
              coinList?.find(
                (coin) =>
                  coin.value === selectedCoin || coin.label === selectedCoin,
              )?.label || "Select Coin"
            }
            onChange={(selectedOption) =>
              handleFilterChange(
                "coin",
                selectedOption?.label ?? selectedOption?.value,
              )
            }
          />
          <Select
            className={style.select_time}
            options={Options}
            formatOptionLabel={(option) => <h5>{option.label}</h5>}
            placeholder={<h5>All</h5>}
            isSearchable={false}
            defaultValue={Options[0]}
            onChange={(selectedOption) =>
              handleFilterChange("transactionType", selectedOption?.value)
            }
          />
          <Select
            className={`${style.select_time} ${style.select_timeWide}`}
            options={sellOptions}
            formatOptionLabel={(option) => <h5>{option.label}</h5>}
            placeholder={<h5>All</h5>}
            isSearchable={false}
            defaultValue={sellOptions[0]}
            onChange={(selectedOption) =>
              handleFilterChange("orderCreatedFrom", selectedOption?.value)
            }
          />
        </div>
      </div>
      <div className={style.reportdetailTable}>
        <div className="tab_data">
          <Table
            noRecordContent={"No records were found."}
            noRecordClassName={style.no_content}
            noContentVariant="large"
            loading={loading}
            loadingClassName={"loading_table"}
            className={style.table}
            fields={tableHeaders}
          >
            {userBalanceData?.length > 0 ? (
              userBalanceData.map((item, index) => (
                <tr key={index}>
                  <td>{(page - 1) * size + index + 1}</td>
                  {/* <td>{index + 1}</td> */}
                  <td>{item?.country || "-"}</td>
                  <td>
                    {item?.date_time &&
                      format(
                        new Date(item?.date_time),
                        "MMM dd, yyyy hh:mm a ",
                      )}
                  </td>
                  <td>{item?.type}</td>
                  <td>{toFix(item?.amount, 3)}</td>
                  {/* <td>
                    {item?.platform_fee}{" "}
                    {item?.platform_fee &&
                      !item?.platform_fee.toString().includes("USD")}
                  </td> */}

                  <td>
                    {selectedCoin === "Gold STBL" ||
                    selectedCoin === "Silver STBL"
                      ? item?.total_platform_fee || "0"
                      : item?.platform_fee || ""}{" "}
                    {selectedCoin !== "Gold STBL" &&
                      selectedCoin !== "Silver STBL" &&
                      item?.platform_fee &&
                      !item?.platform_fee.toString().includes("USD")}
                  </td>
                  <td>{item?.gas_fee != null ? Number(item?.gas_fee) : ""}</td>
                  {/* <td>{item?.platform_fee}</td>
                  <td>{item?.gas_fee}</td> */}
                  <td>{toFix(item?.balance, 3)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={tableHeaders.length}
                  style={{ textAlign: "center" }}
                >
                  No records found!
                </td>
              </tr>
            )}
          </Table>
        </div>
        {userBalanceData?.length > 0 && (
          <Commonpagination
            pagination
            currentPage={page}
            className={style.pagination}
            pageSize={size}
            totalPages={userDetail?.totalPages}
            handlePageChange={(selected) => setPage(selected)}
          />
        )}
      </div>
    </section>
  );
};

export default UserReportDetailTransactions;
